import { cisCurrenciesData } from "../../utils/requests/currenciesList";
import { Period } from "./fetchAndBuildCurrencyExchangeRatesData";
export function getExampleText({ filteredCurrencyKeysList, periodicExchangeRatesData, baseCurrencyText, reverseExchangeRates, }) {
    if (!periodicExchangeRatesData)
        return '';
    const latestExchangeData = periodicExchangeRatesData[Period.latest];
    if (!latestExchangeData)
        return '';
    const exampleCurrencyKey = filteredCurrencyKeysList[0];
    const { name: exampleCurrencyName, symbol: exampleCurrencyFlag } = cisCurrenciesData[exampleCurrencyKey];
    const exampleCurrencyRates = latestExchangeData[exampleCurrencyKey];
    const exampleCurrencyText = (reverseExchangeRates ? exampleCurrencyRates.direct.toFixed(4).toString() : '1')
        .concat(' ', exampleCurrencyFlag)
        .concat(' ', exampleCurrencyName);
    const baseCurrencyExampleValue = reverseExchangeRates ? 1 : exampleCurrencyRates.reverse.toFixed(4);
    const baseCurrencyExampleText = `${baseCurrencyExampleValue} ${baseCurrencyText}`;
    const exampleStrings = [exampleCurrencyText, ' = ', baseCurrencyExampleText];
    const exampleText = (reverseExchangeRates ? exampleStrings.reverse() : exampleStrings).join('');
    return exampleText;
}
;
